import React, { useState, useEffect } from "react";
import { ApolloConsumer } from "react-apollo";
import { CssBaseline, Typography, Snackbar, Button } from "@material-ui/core";

import { AppBar } from "../AppBar";
import useStyles from "./styles";
import { NorpacBottomNavigation } from "../BottomNavigation";
import { SimpleChatBot } from "../../SimpleChatBot";
import { TalkingPoints } from "../../TalkingPoints";
import { Help } from "../../Help";
import { Bills } from "../../TalkingPoints";
import { QRCode } from "../../QRCode";
import { GPS } from "../../GPS";
import { RandomUserIdWrapper } from "../../RandomUserIdWrapper";
import * as serviceWorker from "../../../serviceWorker";

var AWS = require("aws-sdk");
AWS.config.region = "us-east-1";
AWS.config.accessKeyId = "AKIA4UWSNJXTBIABTO6L";
AWS.config.secretAccessKey = "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";

export const lambda = new AWS.Lambda({ region: "us-east-1" });

interface IDashboardProps {
  // userInfo: any;
  // signOutData: any;
}

const Dashboard: React.FC<IDashboardProps> = ({ }) => {
  const classes = useStyles();
  const [leftDrawerOpen, setLeftDrawerOpen] = useState(false);
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [bottomNav, setBottomNav] = useState("chat");
  const [activeConversation, setActiveConversation] = useState({
    id: null,
    name: null,
    conversation: {
      id: null
    }
  });
  const [randUserIdAws, updateRandUserIdAws] = useState("");
  const [showReload, setShowReload] = React.useState(false);
  const [
    waitingWorker,
    setWaitingWorker
  ]: any = React.useState<ServiceWorker | null>(null);

  const onSWUpdate = (registration: ServiceWorkerRegistration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    serviceWorker.register({ onUpdate: onSWUpdate });
    DynamoData();
  }, []);

  const DynamoData = () => {
    var params = {
      FunctionName: "Data-HoneyCode", // the lambda function we are going to invoke
      InvocationType: "RequestResponse",
      Payload: ""
    };
    lambda.invoke(params, function (err: any, data: any) {
      if (err) {
        console.log("Err ", err);
      } else {
        let mainData = JSON.parse(JSON.stringify(data));
        let allData = JSON.parse(mainData.Payload).body;
        // setdynamoData(allData);
        localStorage.setItem("alldataMain", JSON.stringify(allData));
        let SlugMainData =
          allData &&
          allData.map((data: any) =>
            JSON.parse(
              JSON.stringify(data.term)
            )
          );
        localStorage.setItem("allSlugMain", JSON.stringify(SlugMainData));
        // setSlugData(SlugMainData);
      }
    });
  };

  const reloadPage = () => {
    waitingWorker.postMessage({ type: "SKIP_WAITING" });
    setShowReload(false);
    window.location.reload(true);
  };

  return (
    <div>
      <Snackbar
        open={showReload}
        message="A new version is available!"
        onClick={reloadPage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        action={
          <Button color="inherit" size="small" onClick={reloadPage}>
            Reload
          </Button>
        }
      />
      <ApolloConsumer>
        {client => (
          <div className={classes.root}>
            <RandomUserIdWrapper
              client={client}
              updateRandUserIdAws={updateRandUserIdAws}
            />
            <CssBaseline />
            <AppBar
              classes={classes}
              leftDrawer={{ leftDrawerOpen, setLeftDrawerOpen }}
              rightDrawer={{ rightDrawerOpen, setRightDrawerOpen }}
            // signOut={signOutData}
            />
            <main className={classes.content}>
              {bottomNav === "chat" && (
                <>
                  <Typography
                    className={classes.textType}
                    onClick={() =>
                      window.open("https://artificial.chat/", "_blank")
                    }
                  >
                    Powered by Artificial.chat
                  </Typography>
                  <SimpleChatBot
                    client={client}
                    activeConversation={activeConversation}
                    setActiveConversation={setActiveConversation}
                    userId={randUserIdAws}
                  />
                </>
              )}
              {bottomNav === "talking_points" && (
                <>
                  <div className={classes.appBarSpacer} />
                  <TalkingPoints classes={classes} />
                </>
              )}
              {bottomNav === "bills" && (
                <>
                  <div className={classes.appBarSpacer} />
                  <Bills classes={classes} client={client} />
                </>
              )}
              {bottomNav === "help" && (
                <>
                  <div className={classes.appBarSpacer} />
                  <Help classes={classes} client={client} />
                </>
              )}
              {/* {bottomNav === "QRCode" && (
                <>
                  <div className={classes.appBarSpacer} />
                  <QRCode
                    value={"https://tehillim.glossary.chat/"}
                    name={process.env.REACT_APP_BOT_NAME}
                  />
                </>
              )} */}
              {bottomNav === "GPS" && (
                <>
                  <div className={classes.appBarSpacer} />
                  <GPS />
                </>
              )}
            </main>
            <NorpacBottomNavigation
              bottomNav={bottomNav}
              setBottomNav={setBottomNav}
            />
          </div>
        )}
      </ApolloConsumer>
    </div>
  );
};

export default Dashboard;
